import { cn } from '@/core/lib/utils/cn'
import { useAuth } from '@/core/store/auth'
import { Button } from '@/core/ui/atoms/button'
import { useTranslations } from 'next-intl'
import { useOrderSummaryStore } from '../../store'

export const UserDetails = () => {
  const t = useTranslations()
  const { isAuthenticated } = useAuth()
  const { email, phoneNumber, fullName, step, isUpdate } =
    useOrderSummaryStore()
  if (!email && !phoneNumber) {
    return null
  }
  const canUpdate = isAuthenticated && !isUpdate && step > 0 && step < 2
  return (
    <div className='relative mb-8 xl:mb-0'>
      {canUpdate && (
        <Button
          className={cn(
            'bg-lightBlue absolute -bottom-6 z-10 h-7 px-4 py-1 text-white xl:top-0 ltr:xl:right-0 rtl:left-0',
            'hidden',
          )}
          color='pale-blue'
        >
          {t('actions.edit')}
        </Button>
      )}
      <h4 className='text-navy text-sm font-medium'>{}</h4>
      <div className='my-2 flex flex-col gap-1'>
        <p className='text-grey-60 font-medium'>{fullName}</p>
        <p className='text-grey-50 text-sm break-words'>{email}</p>
        <p className='text-grey-50 text-sm'>{phoneNumber}</p>
      </div>
    </div>
  )
}
